(function () {
  function initAlRoutineUpgrade(root) {
    if (!root || root.dataset.alRoutineUpgradeReady === 'true') return;
    root.dataset.alRoutineUpgradeReady = 'true';

    // Add-to-cart is handled by the theme's <product-form> component
    // (product-form.js). This script only keeps the card in sync when a
    // shopper switches variant via the per-card <select>.
    root.addEventListener('change', function (event) {
      var select = event.target.closest('[data-al-ru-variant-select]');
      if (!select) return;

      var card = select.closest('[data-al-ru-card]');
      var selectedOption = select.options[select.selectedIndex];

      if (!card || !selectedOption) return;

      var variantInput = card.querySelector('[data-al-ru-variant-input]');
      var button = card.querySelector('[data-al-ru-button]');
      var label = card.querySelector('.al-ru__button-label');
      var price = card.querySelector('[data-al-ru-price]');
      var titleLink = card.querySelector('.al-ru__title a');
      var mediaLink = card.querySelector('.al-ru__media');
      var image = card.querySelector('[data-al-ru-image]');

      var variantId = selectedOption.value;
      var variantPrice = selectedOption.getAttribute('data-price');
      var variantUrl = selectedOption.getAttribute('data-url');
      var variantImage = selectedOption.getAttribute('data-image');
      var isAvailable = selectedOption.getAttribute('data-available') === 'true';

      if (variantInput) {
        variantInput.value = variantId;
        // A disabled input is excluded from FormData, so only the available
        // variant id is ever submitted.
        variantInput.disabled = !isAvailable;
      }

      if (price && variantPrice) {
        price.textContent = variantPrice;
      }

      if (variantUrl) {
        if (titleLink) titleLink.setAttribute('href', variantUrl);
        if (mediaLink) mediaLink.setAttribute('href', variantUrl);
      }

      if (image && variantImage) {
        image.setAttribute('src', variantImage);
      }

      if (button) {
        button.disabled = !isAvailable;
        button.setAttribute('aria-disabled', isAvailable ? 'false' : 'true');
      }

      if (label) {
        label.textContent = isAvailable ? '+' : '×';
      }

      card.classList.toggle('is-unavailable', !isAvailable);
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.al-ru').forEach(initAlRoutineUpgrade);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    initAll(event.target);
  });
})();
